import axios from 'axios'

const URL_PATH = '/ata-registro-preco/api/public/relatorios/controle-saldo'

class ControleSaldosApiClient {
	async baixarRelatorioControleSaldo(idDocumento) {
		return await axios.get(`${URL_PATH}/${idDocumento}/baixar`, {
			responseType: 'arraybuffer',
		})
	}
}

export default new ControleSaldosApiClient()
